module.exports = __webpack_public_path__ + "img/step2.018e6432.png";